import AppointmentDetails from "../model/appointment/AppointmentDetails";
import UserLocation from "../model/userLocation/UserLocation";
import User from "../model/user/User";
import Event from "../model/event/Event";
import {GeocodingCache} from "./GeocodingCache";

export default class MapUtils {
	/**
	 * Google API KEY
	 * It's empty until we fetch it from the backend.
	 * @type {string}
	 */
	public static API_KEY = "";
	public static MARKER_A = "data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20width%3D%2227px%22%20height%3D%2243px%22%20viewBox%3D%220%200%2027%2043%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%3Cdefs%3E%0A%3Cpath%20id%3D%22a%22%20d%3D%22m12.5%200c-6.9039%200-12.5%205.5961-12.5%2012.5%200%201.8859%200.54297%203.7461%201.4414%205.4617%203.425%206.6156%2010.216%2013.566%2010.216%2022.195%200%200.46562%200.37734%200.84297%200.84297%200.84297s0.84297-0.37734%200.84297-0.84297c0-8.6289%206.7906-15.58%2010.216-22.195%200.89844-1.7156%201.4414-3.5758%201.4414-5.4617%200-6.9039-5.5961-12.5-12.5-12.5z%22%2F%3E%0A%3C%2Fdefs%3E%0A%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%3Cg%20transform%3D%22translate(1%201)%22%3E%0A%3Cuse%20fill%3D%22%23EA4335%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23a%22%2F%3E%0A%3Cpath%20d%3D%22m12.5-0.5c7.18%200%2013%205.82%2013%2013%200%201.8995-0.52398%203.8328-1.4974%205.6916-0.91575%201.7688-1.0177%201.9307-4.169%206.7789-4.2579%206.5508-5.9907%2010.447-5.9907%2015.187%200%200.74177-0.6012%201.343-1.343%201.343s-1.343-0.6012-1.343-1.343c0-4.7396-1.7327-8.6358-5.9907-15.187-3.1512-4.8482-3.2532-5.01-4.1679-6.7768-0.97449-1.8608-1.4985-3.7942-1.4985-5.6937%200-7.18%205.82-13%2013-13z%22%20stroke%3D%22%23fff%22%2F%3E%0A%3C%2Fg%3E%0A%3Ctext%20text-anchor%3D%22middle%22%20dy%3D%220.3em%22%20x%3D%2214%22%20y%3D%2215%22%20font-family%3D%22Roboto%2C%20Arial%2C%20sans-serif%22%20font-size%3D%2216px%22%20fill%3D%22%23FFF%22%3EA%3C%2Ftext%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A";
	public static MARKER_B = "data:image/svg+xml,%3Csvg%20version%3D%221.1%22%20width%3D%2227px%22%20height%3D%2243px%22%20viewBox%3D%220%200%2027%2043%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%3Cdefs%3E%0A%3Cpath%20id%3D%22a%22%20d%3D%22m12.5%200c-6.9039%200-12.5%205.5961-12.5%2012.5%200%201.8859%200.54297%203.7461%201.4414%205.4617%203.425%206.6156%2010.216%2013.566%2010.216%2022.195%200%200.46562%200.37734%200.84297%200.84297%200.84297s0.84297-0.37734%200.84297-0.84297c0-8.6289%206.7906-15.58%2010.216-22.195%200.89844-1.7156%201.4414-3.5758%201.4414-5.4617%200-6.9039-5.5961-12.5-12.5-12.5z%22%2F%3E%0A%3C%2Fdefs%3E%0A%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%3Cg%20transform%3D%22translate(1%201)%22%3E%0A%3Cuse%20fill%3D%22%23EA4335%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23a%22%2F%3E%0A%3Cpath%20d%3D%22m12.5-0.5c7.18%200%2013%205.82%2013%2013%200%201.8995-0.52398%203.8328-1.4974%205.6916-0.91575%201.7688-1.0177%201.9307-4.169%206.7789-4.2579%206.5508-5.9907%2010.447-5.9907%2015.187%200%200.74177-0.6012%201.343-1.343%201.343s-1.343-0.6012-1.343-1.343c0-4.7396-1.7327-8.6358-5.9907-15.187-3.1512-4.8482-3.2532-5.01-4.1679-6.7768-0.97449-1.8608-1.4985-3.7942-1.4985-5.6937%200-7.18%205.82-13%2013-13z%22%20stroke%3D%22%23fff%22%2F%3E%0A%3C%2Fg%3E%0A%3Ctext%20text-anchor%3D%22middle%22%20dy%3D%220.3em%22%20x%3D%2214%22%20y%3D%2215%22%20font-family%3D%22Roboto%2C%20Arial%2C%20sans-serif%22%20font-size%3D%2216px%22%20fill%3D%22%23FFF%22%3EB%3C%2Ftext%3E%0A%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A";
	/**
	 * Key to access Map reference from GoogleMap context
	 * @type {string}
	 */
	public static MAP_REF_CONTEXT_KEY = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

	/**
	 * Populate appointment with GPS location for appointment address.
	 * @param {AppointmentDetails} appointment appointment for which add location.
	 * @return {Promise<AppointmentDetails>}
	 */
	public static populateAppointmentLocation(appointment: AppointmentDetails): Promise<AppointmentDetails> {
		return appointment.site.map(site =>
			GeocodingCache.getCoords(site.data.address.geocodingAddress()).then(location => appointment.copy({location})))
			.getOrElse(new Promise<AppointmentDetails>(resolve => resolve(appointment)))
	}

	/**
	 * Populate users with GPS location of it home address.
	 * @param {User} user
	 * @return {Promise<User>}
	 */
	public static populateUserLocation(user: User): Promise<User> {
		return user.data.homeAddress.map(address => {
			return GeocodingCache.getCoords(address.geocodingAddress())
				.then(location => {
					const data = user.data.copy({homeAddressLocation: location});
					return user.copy({data});
				}).catch(() => Promise.resolve(user));
		}).getOrElse(() => Promise.resolve(user));
	}

	/**
	 * Generate home marker with custom attributes applied.
	 * @param {string} value unique value for which generate color of the marker.
	 * @return {string} svg element of home address marker.
	 */
	public static getHomeMarker(value: string): string {
		const svg = `<svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg"  
				 		x="0px" y="0px" width="22px" height="22px"	viewBox="0 0 22 22" xml:space="preserve">
						<g fill="${value.toHexColour()}">
							<path d="M11,0C7.962,0,5.5,2.462,5.5,5.5C5.5,9.9,9.9,11,11,22c1.1-11,5.5-12.1,5.5-16.5C16.5,2.462,14.038,0,11,0z M14.808,5.064
							c-0.019,0.045-0.073,0.125-0.233,0.125h-0.4v2.958c0,0.303-0.252,0.568-0.554,0.568h-1.797V6.708H10.13v2.006H8.38
							c-0.3,0-0.566-0.26-0.566-0.568V5.188H7.426c-0.161,0-0.215-0.079-0.234-0.125S7.16,4.922,7.276,4.811l3.453-3.328
							c0.072-0.07,0.169-0.108,0.271-0.108s0.199,0.039,0.272,0.108l3.453,3.328C14.84,4.922,14.826,5.019,14.808,5.064z"/>
						</g>
					</svg>`;
		return (`data:image/svg+xml;utf-8,${encodeURIComponent(svg)}`)
	}

	/**
	 * Generate marker with user's name initials and custom attributes applied.
	 * @param {User} user for which generate color of the marker.
	 * @param {UserLocation} location user last location.
	 * @returns {string} svg element of current position marker.
	 */
	public static getCurrentPositionMarker(user: User, location: UserLocation) {
		const offlineColor = location.isOffline() ? "grey" : "green";
		const svg = `<svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg"  
						 x="0px" y="0px" width="44px" height="44px"	viewBox="0 0 44 44" xml:space="preserve">
						<g>
							<circle fill="none" stroke="${offlineColor}" cx="22" cy="22" r="21"/>
							<circle fill="${user.id.toHexColour()}" cx="22" cy="22" r="19"/>
							<text x="50%" y="63%" text-anchor="middle" font-family="sans-serif" font-size="14px" fill="white">${user.getInitials()}</text>
						</g>
					</svg>`;
		return (`data:image/svg+xml;utf-8,${encodeURIComponent(svg)}`);
	}

	/**
	 * Generate marker with user's name initials in a colored circle.
	 * @param {User} user for which generate color of the marker.
	 * @returns {string} svg element
	 */
	public static getSEInitialsMarker(user: User) {
		const svg = `<svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" 
								x="0px" y="0px" width="36px" height="36px" viewBox="0 0 38 38" xml:space="preserve">
  							<circle cx="19" cy="19" r="19" fill="${user.id.toHexColour()}"/>
 							<text x="50%" y="63%" text-anchor="middle" font-family="sans-serif" font-size="14px" fill="white">${user.getInitials()}</text>
					</svg>`;
		return (`data:image/svg+xml;utf-8,${encodeURIComponent(svg)}`);
	}

	/**
	 * Get marker for event
	 * @param {Event} event
	 * @returns {string} svg element
	 */
	public static getEventMarker(event: Event) {
		const colors = event.isLeadAppointment ? {
			markerFill: "#e22c29",
			markerStroke: "#d42926",
			dotFill: "#83000b"
		} : {
			markerFill: "#ff8671",
			markerStroke: "#ff664b",
			dotFill: "#924236"
		};
		const svg = `<svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" 
 							x="0px" y="0px" width="28px" height="45px" viewBox="0 0 28 45" xml:space="preserve">
						<g>
							<path d="M 14.03572,43.6859 C 13.04156,38.8056 11.28871,34.7443 9.16562,30.9802 7.59083,28.1882 5.76651,25.6111
							 	4.07854,22.9036 3.51506,21.9998 3.02878,21.0449 2.48733,20.1069 1.4047,18.2313 0.52691,16.0566 0.58269,13.2357
							  	0.63719,10.4796 1.43432,8.26866 2.58379,6.46098 4.47432,3.48781 7.64104,1.05013 11.89001,0.40952 c 3.47405,-0.52378
							   	6.73122,0.36113 9.04103,1.71176 1.88749,1.10372 3.34916,2.57803 4.46021,4.31557 1.15967,1.81353 1.95824,3.95605
							    2.02523,6.75065 0.0343,1.4318 -0.20017,2.7577 -0.53045,3.8575 -0.33426,1.1132 -0.87183,2.0438 -1.35012,3.0378
							 	-0.93363,1.9402 -2.10416,3.718 -3.27886,5.4969 -3.49895,5.2984 -6.78305,10.702 -8.22133,18.1062 z" 
							     fill="${colors.markerFill}"
							     stroke="${colors.markerStroke}"
							    />
							<circle cx="14" cy="14" fill="${colors.dotFill}" r="5"/>
						</g>
					</svg>`;
		return (`data:image/svg+xml;utf-8,${encodeURIComponent(svg)}`);
	}
}
